import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-950/95 backdrop-blur-md shadow-lg shadow-black/20'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="font-heading text-xl md:text-2xl font-bold text-primary-500 group-hover:text-primary-400 transition-colors">
              17黑料网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-800/50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="text-sm text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
            <Link
              to="/#subscribe"
              className="px-5 py-2 text-sm bg-primary-500 hover:bg-primary-600 text-white rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              订阅爆料
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-200"
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-background-800 py-4">
            <div className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2.5 text-sm rounded-lg transition-colors ${
                    location.pathname === `/category/${cat.slug}`
                      ? 'bg-primary-500/20 text-primary-400'
                      : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-800'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <div className="border-t border-background-800 pt-2 mt-2 flex flex-col gap-2">
                <Link
                  to="/about"
                  className="px-4 py-2.5 text-sm text-foreground-400 hover:text-foreground-200 rounded-lg hover:bg-background-800 transition-colors"
                >
                  关于我们
                </Link>
                <Link
                  to="/#subscribe"
                  className="px-4 py-2.5 text-sm bg-primary-500 text-white rounded-lg text-center"
                >
                  订阅爆料
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}